@let calculationModulesState = calculationModulesState$();
@if (calculationModulesState.status === 'loading') {
  <div class="spinner-container">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
} @else if (calculationModulesState.status === 'error') {
  <p class="no-data">
    No calculation module available. <br />
    Please, try again later.
  </p>
} @else {
  <div class="header-search sticky">
    <mat-form-field subscriptSizing="dynamic" class="search">
      <input
        matInput
        placeholder="Search calculation modules..."
        [(ngModel)]="search$"
        (ngModelChange)="search$.set($event)"
      />
      <button
        matIconButton
        matSuffix
        (click)="clearSearch()"
        aria-label="Clear search"
        matTooltip="Clear search"
      >
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>
    <button
      matIconButton
      class="icon-button-warn clear-cms"
      (click)="unselectAllCMs()"
      matTooltip="Unselect all CM layers"
    >
      <mat-icon fontIcon="layers_clear"></mat-icon>
    </button>
  </div>

  <div class="content-container">
    @for (category of categories$(); track $index) {
      @if ((filteredCalculationModules$() | filterCMOnCategory: category).length > 0) {
        <mat-accordion>
          <mat-expansion-panel expanded>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ category }}
              </mat-panel-title>
              <!-- <mat-panel-description> Something can be useful here</mat-panel-description> -->
            </mat-expansion-panel-header>
            <div class="session-of-a-category">
              @for (
                cm of filteredCalculationModules$() | filterCMOnCategory: category;
                track $index
              ) {
                <div [id]="cm.cm_id" class="a-cm-with-sessions">
                  <span
                    [matTooltip]="formatLevelAvailabilityToolTip(cm)"
                    matTooltipPosition="below"
                  >
                    <button
                      class="cm-title"
                      matButton="outlined"
                      type="button"
                      (click)="selectCM(cm)"
                    >
                      {{ cm.cm_name }}
                    </button>
                  </span>
                  <div class="cm-session-list">
                    @if (cmSessions$()) {
                      @for (cmSession of cmSessions$(); track $index) {
                        @if (cmSession.cm_id == cm.cm_id) {
                          <app-cm-sessions [cmSession]="cmSession"></app-cm-sessions>
                        }
                      }
                    }
                  </div>
                </div>
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      }
    }

    @if (toolchainScenarios && toolchainScenarios.length > 0) {
      @if (filteredCalculationModules$().length == calculationModules$().length) {
        <app-toolchain-scenarios></app-toolchain-scenarios>
      } @else if (search$() !== '') {
        <p>Search not available for toolchain-scenarios.</p>
      }
    }
    @if (standaloneCMs && standaloneCMs.length > 0) {
      @if (filteredCalculationModules$().length == calculationModules$().length) {
        <app-stand-alone-cms></app-stand-alone-cms>
      } @else if (search$() !== '') {
        <p>Search not yet available for standalone CM.</p>
      }
    }
  </div>
}
